import React from 'react';
import clsx from 'clsx';
import ReactPaginate from 'react-paginate';

import { Left } from './Left';
import { Right } from './Right';

type PaginatedItemsProps = {
  totalItems?: number;
  itemsPerPage?: number;
  className?: string;

  page?: number;
  setPage?: (page: number) => void;
};

export const Paginate: React.FC<PaginatedItemsProps> = ({
  className,
  totalItems = 1,
  itemsPerPage = 1,

  setPage,
  page = 1,
}) => {
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  const handlePageClick = (event: any) => {
    setPage?.(event.selected + 1);
  };

  const pageControlClassName =
    'flex items-center justify-center shrink-0 px-2 py-2 min-w-11 h-11 tabular-nums';

  return (
    <>
      <ReactPaginate
        className={clsx(
          className,
          'flex flex-wrap gap-x-3 items-center text-medium'
        )}
        disabledClassName="opacity-20 cursor-not-allowed"
        pageClassName="rounded-sm hover:bg-dark cursor-pointer shrink-0"
        activeClassName="border-2 border-main hover:bg-contrast"
        pageLinkClassName={pageControlClassName}
        breakClassName="shrink-0"
        breakLinkClassName={pageControlClassName}
        nextClassName="hover:bg-dark p-2 rounded-sm shrink-0"
        previousClassName="hover:bg-dark p-2 rounded-sm shrink-0"
        breakLabel="..."
        nextLabel={<Left />}
        pageCount={pageCount || 1}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        previousLabel={<Right />}
        renderOnZeroPageCount={null}
        onPageChange={handlePageClick}
        forcePage={page - 1}
      />
    </>
  );
};
